export default "__VITE_ASSET__CzTaFGLN__"